import React, { useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import AdminLink from "./adminLink";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import { FiInfo } from "react-icons/fi";
import { AiOutlineEye } from "react-icons/ai";
import TestForPackage from "./testsByPackagePopup";
import "./hm-theme.css";

function CompanySettings({ selectedOrgcode }) {
  const [loader, setLoader] = useState(true);
  const [isEmployeePaymentEnabled, setIsEmployeePaymentEnabled] = useState(false);
  const [isFamilyPaymentEnabled, setIsFamilyPaymentEnabled] = useState(false);
  const [isAnnualCheckup, setIsAnnualCheckup] = useState(false);
  const [isRestrictedPkgByDesignation, setIsRestrictedPkgByDesignation] = useState(false);
  const [isPackageByAge, setIsPackageByAge] = useState(false);
  const [isBmiCalculator, setIsBmiCalculator] = useState(false);
  const [isAgeBasedRecommendations, setIsAgeBasedRecommendations] = useState(false);
  const [isEnableRegistration, setIsEnableRegistration] = useState(false);
  const [isHomeCollection, setIsHomeCollection] = useState(false);
  const [isCategory, setIsCategory] = useState(false);

  const userRole = JSON.parse(localStorage.getItem("data")).role;
  const [companyDetails, setCompanyDetails] = useState(null);
  const [pemePackage, setPemePackage] = useState(null);

  const [isTestsModalOpen, setIsTestsModalOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [companyPackages, setCompanyPackages] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const navigate = useNavigate();

  const getData = async () => {
    setLoader(true);
    const token = JSON.parse(localStorage.getItem("data")).token;
    try {
      const response = await axios.get(`/api/companydetails/companycode=${selectedOrgcode}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setCompanyDetails(response.data);
      setIsEmployeePaymentEnabled(response.data?.requireEmpPayment || false);
      setIsFamilyPaymentEnabled(response.data?.requireFamilyPayment || false);
      setIsAnnualCheckup(response.data?.annualCheckupController || false);
      setIsRestrictedPkgByDesignation(response.data?.restrictedPkgByDesignation || false);
      setIsPackageByAge(response.data?.packageByAge || false);
      setIsBmiCalculator(response.data?.bmiCalculator || false);
      setIsAgeBasedRecommendations(response.data?.ageBasedRecommendations || false);
      setIsEnableRegistration(response.data?.enableRegistration || false);
      setIsHomeCollection(response.data?.homeCollection || false);
      setIsCategory(response.data?.packageByCategory || false);

      const pemePackageId = response.data?.pemePackageId;
      if (pemePackageId !== null) {
        const pemeRes = await axios.get(`/api/package/${response.data?.pemePackageId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setPemePackage(pemeRes.data);
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  const handleToggleChange = async (type, value) => {
    setLoader(true);
    const token = JSON.parse(localStorage.getItem("data")).token;
    try {
      const payload = {
        ...companyDetails,
        [type]: value,
      };
      await axios.post(`/api/companydetails/update`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success("Setting updated successfully!");
      getData();
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  const openPackageModal = async () => {
    try {
      const token = JSON.parse(localStorage.getItem("data")).token;
      const response = await axios.get(`/api/package/companyId=${companyDetails?.id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const filteredPackages = response.data.filter(
        (pkg) => pkg.id !== companyDetails?.pemePackageId
      );
      setCompanyPackages(filteredPackages);
      setShowModal(true);
    } catch (error) {
      toast.error("Failed to fetch packages.");
    }
  };

  const handlePackageSelection = async (packageId) => {
    setLoader(true);
    const token = JSON.parse(localStorage.getItem("data")).token;
    try {
      const payload = {
        ...companyDetails,
        pemePackageId: packageId
      };
      await axios.post(`/api/companydetails/update`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success(`PEME package updated successfully!`);
      setShowModal(false);
      getData();
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  const openTestsModal = (pkg) => {
    setSelectedPackage(pkg);
    setIsTestsModalOpen(true);
  };

  function handleError(error) {
    if (error.response?.status === 401) {
      navigate(`/signin`);
      toast.error("Your session has expired. Please login.");
    } else {
      toast.error(error.response?.data?.message || error.message || "An error occurred.");
    }
  }

  useEffect(() => {
    getData();
  }, []);

  const SettingTile = ({ id, label, description, checked, onChange }) => (
    <div className="d-flex align-items-center justify-content-between p-3 border rounded-3 mb-3 bg-light shadow-sm">
      <div>
        <h6 className="fw-bold mb-1">{label}</h6>
        <p className="text-muted small mb-0">{description}</p>
      </div>
      <div className="d-flex align-items-center gap-3">
        <span className={checked ? "hm-badge hm-badge-success" : "hm-badge hm-badge-danger"}>
          {checked ? "Active" : "Disabled"}
        </span>
        <div className="form-check form-switch m-0">
          <input
            className="form-check-input"
            type="checkbox"
            id={id}
            checked={checked}
            onChange={onChange}
            style={{ width: "2.5rem", height: "1.3rem", cursor: "pointer" }}
          />
        </div>
      </div>
    </div>
  );

  return (
    <div>
      {userRole === "ROLE_SUPER" && <AdminLink selectedOrgcode={selectedOrgcode} />}
      {loader && <div className="loading"></div>}

      <div className="hm-page-wrapper">
        {/* General Settings */}
        <div className="hm-card mb-4">
          <div className="hm-card-header">
            <h4 className="hm-card-title">
              <i className="material-icons">settings</i>
              General Company Settings
            </h4>
          </div>
          <div className="hm-card-body">
            <div className="row">
              <div className="col-md-6">
                <SettingTile
                  id="employeePaymentToggle"
                  label="Employee Payment"
                  description="Require payment from employees during booking"
                  checked={isEmployeePaymentEnabled}
                  onChange={(e) => handleToggleChange("requireEmpPayment", e.target.checked)}
                />
              </div>
              <div className="col-md-6">
                <SettingTile
                  id="familyPaymentToggle"
                  label="Family Payment"
                  description="Require payment from family members during booking"
                  checked={isFamilyPaymentEnabled}
                  onChange={(e) => handleToggleChange("requireFamilyPayment", e.target.checked)}
                />
              </div>
              <div className="col-md-6">
                <SettingTile
                  id="annualCheckupToggle"
                  label="Annual Checkup Controller"
                  description="Enable annual health checkup tracking"
                  checked={isAnnualCheckup}
                  onChange={(e) => handleToggleChange("annualCheckupController", e.target.checked)}
                />
              </div>
              <div className="col-md-6">
                <SettingTile
                  id="restrictedPkgByDesignation"
                  label="Package By Designation"
                  description="Restrict test packages based on employee designation"
                  checked={isRestrictedPkgByDesignation}
                  onChange={(e) => handleToggleChange("restrictedPkgByDesignation", e.target.checked)}
                />
              </div>
              <div className="col-md-6">
                <SettingTile
                  id="packageByAge"
                  label="Package By Age"
                  description="Assign test packages based on employee age"
                  checked={isPackageByAge}
                  onChange={(e) => handleToggleChange("packageByAge", e.target.checked)}
                />
              </div>
              <div className="col-md-6">
                <SettingTile
                  id="enableRegistration"
                  label="Enable Registration"
                  description="Allow new employee self-registration"
                  checked={isEnableRegistration}
                  onChange={(e) => handleToggleChange("enableRegistration", e.target.checked)}
                />
              </div>
              <div className="col-md-6">
                <SettingTile
                  id="homeCollectionToggle"
                  label="Home Collection"
                  description="Check lab mandatory for each test in appointment booking for home collection eligibility"
                  checked={isHomeCollection}
                  onChange={(e) => handleToggleChange("homeCollection", e.target.checked)}
                />
              </div>
              <div className="col-md-6">
                <SettingTile
                  id="categoryToggle"
                  label="Package By Category"
                  description="Enable booking category configuration for appointment booking"
                  checked={isCategory}
                  onChange={(e) => handleToggleChange("packageByCategory", e.target.checked)}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Recommendation Settings */}
        <div className="hm-card mb-4">
          <div className="hm-card-header">
            <h4 className="hm-card-title">
              <i className="material-icons">tips_and_updates</i>
              Test Recommendation Rules
            </h4>
          </div>
          <div className="hm-card-body">
            <div className="row g-3">
              <div className="col-md-6">
                <div className="p-3 border rounded-3 bg-light shadow-sm d-flex align-items-center justify-content-between">
                  <div>
                    <h6 className="fw-bold mb-1">BMI Based Recommendations</h6>
                    <p className="text-muted small mb-0">Recommend additional tests using BMI calculations</p>
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <span className={isBmiCalculator ? "hm-badge hm-badge-success" : "hm-badge hm-badge-danger"}>
                      {isBmiCalculator ? "Active" : "Off"}
                    </span>
                    <div className="form-check form-switch m-0">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={isBmiCalculator}
                        onChange={(e) => handleToggleChange("bmiCalculator", e.target.checked)}
                        style={{ width: "2.5rem", height: "1.3rem", cursor: "pointer" }}
                      />
                    </div>
                    {isBmiCalculator && (
                      <button
                        className="btn btn-outline-primary btn-sm rounded-pill"
                        onClick={() => navigate(`/users/bmi-recommendation-rules/${companyDetails?.id}`)}
                      >
                        Rules
                      </button>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="p-3 border rounded-3 bg-light shadow-sm d-flex align-items-center justify-content-between">
                  <div>
                    <h6 className="fw-bold mb-1">Age Based Recommendations</h6>
                    <p className="text-muted small mb-0">Recommend tests based on patient age thresholds</p>
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <span className={isAgeBasedRecommendations ? "hm-badge hm-badge-success" : "hm-badge hm-badge-danger"}>
                      {isAgeBasedRecommendations ? "Active" : "Off"}
                    </span>
                    <div className="form-check form-switch m-0">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={isAgeBasedRecommendations}
                        onChange={(e) => handleToggleChange("ageBasedRecommendations", e.target.checked)}
                        style={{ width: "2.5rem", height: "1.3rem", cursor: "pointer" }}
                      />
                    </div>
                    {isAgeBasedRecommendations && (
                      <button
                        className="btn btn-outline-primary btn-sm rounded-pill"
                        onClick={() => navigate(`/users/age-recommendation-rules/${companyDetails?.id}`)}
                      >
                        Rules
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* PEME Package */}
        <div className="hm-card mb-4">
          <div className="hm-card-header">
            <h4 className="hm-card-title">
              <i className="material-icons">local_hospital</i>
              PEME Package Configuration
            </h4>
          </div>
          <div className="hm-card-body">
            {!companyDetails?.pemePackageId ? (
              <div className="text-center py-4">
                <p className="text-muted mb-3">No PEME package linked yet</p>
                <button className="btn-hm-primary" onClick={openPackageModal}>
                  <i className="material-icons" style={{ fontSize: "1rem" }}>link</i>
                  Link PEME Package
                </button>
              </div>
            ) : (
              <div>
                {pemePackage ? (
                  <div style={{ overflowX: "auto" }}>
                    <table className="hm-table">
                      <thead>
                        <tr>
                          <th>Package Name</th>
                          <th>Code</th>
                          <th>Price</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="fw-semibold">
                            {pemePackage.packagename}
                            <FiInfo
                              onClick={() => openTestsModal(pemePackage.id)}
                              style={{ cursor: "pointer", marginLeft: "8px", color: "#2cb6e9" }}
                              title="View Tests"
                            />
                          </td>
                          <td><code>{pemePackage.packageCode}</code></td>
                          <td className="fw-bold">₹ {pemePackage.price}</td>
                          <td>
                            <button className="btn btn-outline-warning btn-sm rounded-pill" onClick={openPackageModal}>
                              Change Package
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <p className="text-muted text-center m-0">Loading package details...</p>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      {isTestsModalOpen && (
        <TestForPackage
          isOpen={isTestsModalOpen}
          onRequestClose={() => setIsTestsModalOpen(false)}
          packageId={selectedPackage}
        />
      )}

      {/* Package Selection Modal */}
      {showModal && (
        <div className="modal show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content hm-card">
              <div className="hm-card-header">
                <h5 className="hm-card-title">Select PEME Package</h5>
                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <div className="hm-card-body" style={{ maxHeight: "60vh", overflowY: "auto" }}>
                {companyPackages.length > 0 ? (
                  companyPackages.map((pkg) => (
                    <div key={pkg.id} className="d-flex justify-content-between align-items-center p-3 border rounded-3 mb-2 bg-light">
                      <span className="fw-semibold">{pkg.packagename}</span>
                      <button className="btn-hm-primary btn-sm" onClick={() => handlePackageSelection(pkg.id)}>
                        Select
                      </button>
                    </div>
                  ))
                ) : (
                  <p className="text-muted text-center py-3">No packages available.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CompanySettings;
